import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleChartComponent } from './google-chart.component';

@NgModule({
  declarations: [GoogleChartComponent],
  imports: [CommonModule],
  exports: [GoogleChartComponent]
})
export class GoogleChartsModule { }
